
import {getHistoryFootData,addHistoryFootData} from '@/config/prepare.js';

export function _init_makers($brtmap){

    let $rangeAngle = 0;     //一定范围不转动定位指针

    let $navRssi   = null;   //导航过程中信号值改变处理

    $brtmap.$marker = {};
    //定位点
    $brtmap.$marker.location = {

        //是否开始第一视角
        isFirst:false,

        circle: new brtmap.Symbol.Circle({
            radius:40,
            color:'#0099ff',
            opacity:0.3,
            type:'map'
        }).addTo($VAR.map),

        ico: new brtmap.Symbol.Marker({
            url:'./images/loc2.png',
            size:0.6,
            offset:[0,-40],
            type:'map'
        }).addTo($VAR.map),

        marker: new brtmap.Symbol.Marker({
            url:'./images/loc.png',
            size:0.8,
            offset:[0,-9],
            type:'map'
        }).addTo($VAR.map),

        setLnglat:function(lnglat,floor){

            if( !floor )floor = $VAR.map.currentMapInfo.floorNumber;    //当前楼层

            var floorID = $VAR.map.getFloorInfoByIndex(floor).floorID;

            // $brtmap.$marker.location.circle.setLnglat(lnglat, floorID);
            $brtmap.$marker.location.marker.setLnglat(lnglat, floorID);

            if($brtmap.$marker.location.isFirst){

                $brtmap.$marker.location.ico.setLnglat(lnglat, floorID);

            }else{

                $brtmap.$marker.location.ico.empty();

            }

        },

        setAngle:function(angle){

            //一定角度区间内不改变(取绝对值)
            // if(Math.abs($rangeAngle - angle) < 15) return;
            $rangeAngle = angle;

            $brtmap.$marker.location.marker.setRotate($rangeAngle);

            if($brtmap.$marker.location.isFirst){
                $brtmap.$marker.location.ico.setRotate($rangeAngle);

            }

        },

        empty:function(){
            $brtmap.$marker.location.ico.empty();
            $brtmap.$marker.location.circle.empty();
            $brtmap.$marker.location.marker.empty();
        }

    }

    $brtmap.$marker.navLocation = {
        //是否开始第一视角
        isFirst:false,

        icon: new brtmap.Symbol.Marker({
            url:'./images/nav-icon.png',
            size:0.55,
            type:'map'
        }).addTo($VAR.map),

        ico: new brtmap.Symbol.Marker({
            url:'./images/loc2.png',
            size:0.6,
            offset:[0,-40],
            type:'map'
        }).addTo($VAR.map),

        marker: new brtmap.Symbol.Marker({  //信号正常
            url:'./images/nav-normal.png',
            size:0.55,
            offset:[0, 2],
            type:'map'
        }).addTo($VAR.map),

        markerCar: new brtmap.Symbol.Marker({  //信号正常
            url:'./images/vehicle.png',
            size:0.55,
            offset:[0, 2],
            type:'map'
        }).addTo($VAR.map),

        /*采用setURL方式代替 setURL容易使图片无效*/
        markerNo: new brtmap.Symbol.Marker({    //没信号
            url:'./images/nav-nosignal.png',
            size:0.55,
            offset:[0, 2],
            type:'map'
        }).addTo($VAR.map),

        markerWeak: new brtmap.Symbol.Marker({  //信号弱
            url:'./images/nav-weak.png',
            size:0.55,
            offset:[0, 2],
            type:'map'
        }).addTo($VAR.map),

        setLnglat:function(lnglat, floor,rssi){

            if( !floor )floor = $VAR.map.currentMapInfo.floorNumber;    //当前楼层
            var floorID = $VAR.map.getFloorInfoByIndex(floor).floorID;


            if($brtmap.$route.vehicle){
                //车行
                $brtmap.$marker.navLocation.icon.setLnglat(lnglat, floorID);
                $brtmap.$marker.navLocation.markerCar.setLnglat(lnglat, floorID);


            }else{

                //人行
                let str;

                if($navRssi != -999 && $navRssi != rssi){  //处理信号变化

                    $navRssi = -999;    //正在切换中

                    //信号处理
                    if(rssi <= 0){//没信号

                        str = 'markerNo';
                        // $brtmap.$marker.navLocation.marker.setURL('./images/nav-nosignal.png');

                    }else if(rssi && rssi == 1){  //信号弱
                        str = 'markerWeak';
                        // $brtmap.$marker.navLocation.marker.setURL('./images/nav-weak.png');

                    }else{      //信号正常
                        str = 'marker'
                        // $brtmap.$marker.navLocation.marker.setURL('./images/nav-normal.png');
                    }

                    $navRssi = rssi;

                    //防止图标不出现
                    // setTimeout(function () {$navRssi = rssi;},50)   //切换完成改变状态

                }

                if($navRssi == rssi){

                    $brtmap.$marker.navLocation.icon.setLnglat(lnglat, floorID);

                    $brtmap.$marker.navLocation.marker.empty();
                    $brtmap.$marker.navLocation.markerWeak.empty();
                    $brtmap.$marker.navLocation.markerNo.empty();


                    if(str == 'markerNo'){

                        $brtmap.$marker.navLocation.markerNo.setLnglat(lnglat, floorID);

                    }else if(str == 'markerWeak'){

                        $brtmap.$marker.navLocation.markerWeak.setLnglat(lnglat, floorID);

                    }else{

                        $brtmap.$marker.navLocation.marker.setLnglat(lnglat, floorID);

                    }


                    if($brtmap.$marker.navLocation.isFirst){

                        // $brtmap.$marker.navLocation.ico.setLnglat(lnglat, floorID);

                    }else{
                        $brtmap.$marker.navLocation.ico.empty();
                    }

                }
            }


        },

        setAngle:function(angle){
            // $brtmap.$marker.navLocation.ico.setRotate(angle);
            $brtmap.$marker.navLocation.marker.setRotate(angle);
            $brtmap.$marker.navLocation.markerNo.setRotate(angle);
            $brtmap.$marker.navLocation.markerWeak.setRotate(angle);
            $brtmap.$marker.navLocation.markerCar.setRotate(angle);


        },

        setCommpassAngle: (angle) => {  //东南西北图标
            $brtmap.$marker.navLocation.icon.setRotate(angle);
        },

        empty:function(){

            $brtmap.$marker.navLocation.icon.empty();
            $brtmap.$marker.navLocation.marker.empty();
            $brtmap.$marker.navLocation.markerWeak.empty();
            $brtmap.$marker.navLocation.markerNo.empty();
            $brtmap.$marker.navLocation.ico.empty();
            $brtmap.$marker.navLocation.markerCar.empty();

        }

    }

    //虚拟定位点
    $brtmap.$marker.virtualLocation = {

        //是否开始第一视角
        isFirst:false,

        circle: new brtmap.Symbol.Circle({
            radius:40,
            color:'#0099ff',
            opacity:0.3,
            type:'map'
        }).addTo($VAR.map),

        ico: new brtmap.Symbol.Marker({
            url:'./images/loc2.png',
            size:0.6,
            offset:[0,-40],
            type:'map'
        }).addTo($VAR.map),

        marker: new brtmap.Symbol.Marker({
            url:'./images/loc3.png',
            size:0.8,
            offset:[0,-9],
            type:'map'
        }).addTo($VAR.map),

        setLnglat:function(lnglat,floor){

            if( !floor )floor = $VAR.map.currentMapInfo.floorNumber;    //当前楼层

            var floorID = $VAR.map.getFloorInfoByIndex(floor).floorID;

            // $brtmap.$marker.virtualLocation.circle.setLnglat(lnglat, floorID);
            $brtmap.$marker.virtualLocation.marker.setLnglat(lnglat, floorID);

            // if($brtmap.$marker.virtualLocation.isFirst){
            //
            //     $brtmap.$marker.virtualLocation.ico.setLnglat(lnglat, floorID);
            //
            // }else{
            //
            //     $brtmap.$marker.virtualLocation.ico.empty();
            //
            // }

        },

        setAngle:function(angle){

            //一定角度区间内不改变(取绝对值)
            // if(Math.abs($rangeAngle - angle) < 15) return;
            $rangeAngle = angle;

            $brtmap.$marker.virtualLocation.marker.setRotate($rangeAngle);

            // if($brtmap.$marker.virtualLocation.isFirst){
            //     $brtmap.$marker.virtualLocation.ico.setRotate($rangeAngle);
            // }

        },

        empty:function(){
            // $brtmap.$marker.location.ico.empty();
            // $brtmap.$marker.location.circle.empty();
            $brtmap.$marker.virtualLocation.marker.empty();
        }

    }

    //小红点
    $brtmap.$marker.point = new brtmap.Symbol.DivMarker({
        content:'<i class="point"></i>',
        className:'locatePoint-marker',
    }).addTo($VAR.map);


    //选中poi
    $brtmap.$marker.selected = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap">' +
        '<div class="border"></div>' +
        '<div class="bg"></div>' +
        '<i class="poi-icon-null"></i>'+
        '</div>',
        className:'selected-marker',
    }).addTo($VAR.map);

    //起点
    $brtmap.$marker.start = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap">' +
        '<div class="border"></div>' +
        '<div class="bg"></div>' +
        '<i></i>' +
        '</div>'+
        '<div class="tip"><i></i> <div class="txt">起点</div></div>',
        className:'point-marker start',
    }).addTo($VAR.map);


    //途径点
    $brtmap.$marker.keyPoint = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap">' +
            '<div class="border"></div>' +
            '<div class="bg"></div>' +
            '<i></i>' +
            '</div>' + `<i class="iconfont icon-close-01""></i>`,
        className:'point-marker keyPoint',
    }).addTo($VAR.map);

    $brtmap.$marker.keyPoint.on('click',e=>{
        e.stopPropagation();
    })


    //终点
    $brtmap.$marker.end = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap">' +
        '<div class="border"></div>' +
        '<div class="bg"></div>' +
        '<i></i>' +
        '</div>'+
        '<div class="tip"><i></i> <div class="txt">终点</div></div>',
        className:'point-marker end',
    }).addTo($VAR.map);


    //筛选poi图标
    $brtmap.$marker.filter = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap"><div class="icon-box"><i class="poi-icon-null"></i></div> </div>',
        className:'filter-marker',
    }).addTo($VAR.map);


    //上行 下行 提示
    $brtmap.$marker.tipPopup = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap">' +
        '<div class="txt">' +
        '<i class="iconfont icon-zuji"></i>' +
        '<span>上行至L2层</span>' +
        '</div>' +
        '       </div>',
        className:'tip-popup-marker'
    }).addTo($VAR.map);


    //单店活动
    $brtmap.$marker.shopActive = new brtmap.Symbol.DivMarker({
        content:'<div class="wrap">' +
        '<p>我是测试111我是测试111我是测试111我是测试111我是测试111我是测试111</p>' +
        '<p>我是测试111</p>' +
        '<p>我是测试111</p>' +
        '</div>',
        className:'shop-marker',
    }).addTo($VAR.map);

    //

}




//定位相关的
export function _init_locate($brtmap,$plugInfo) {

    $brtmap.$NAVTO.$NAVSIMULATE = {};
    $brtmap.$NAVTO.$NAVINDICATE = {};

}


//导航相关
export function _init_nav() {

    let $brtmap = this.$store.state.mapStore.brtmap,
        $pluset = this.$mapStore.plugInfo.plugInfo.plugInSettings,
        $plugNav = JSON.parse($pluset.navigation),
        $marker = $brtmap.$marker;

        $VAR.$nav = new brtmap.Navigation({

           // markerFollowRouteAngle:true,           //定位标记图标跟随路线转动 (可设置)

            voice:false,                             //语音开关 (可设置)

            openInertance:true,                         //惯性运动导航(车行导航)

            advanceDistance:2,                      //超前米数（定位点延迟）

            inertanceSpeed:$plugNav.simspeed || 2,  //惯性运动速度(米/s)

            inertanceStartNumber:0.1,                 //惯性启动前（防止不动就前行） 不开惯性需设置2，表示走过2米开始走

            yawDistance:10,                         //导航中偏航偏移距离

            yawDelayTime:1000,                      //偏转延迟时间ms (可设置)

            earlyDistance:0,                        //提前结束 (可设置)

            indicateDistance:15                     //拐角提示提前距离

        }).addTo($VAR.map);

    $VAR.$nav.followBearing = true;
    $VAR.$nav.markerFollowRouteAngle = false;

    //计算次数
    $VAR.$nav.pointCount = 0;

    let $this = this,
        $indicateTip,
        $door,
        $routes,
        $startStatus,
        $endStatus,
        $b_tip_t,
        $residue,
        startUpdata,    //开始上报
        $floor,         //楼层记录
        cNodes,         //存本层节点
        $floorZoom,     //层级记录
        $indicate = new brtmap.NavIndicate().addTo($VAR.map);


    let st = 0,$navPoint='';


    // console.log('$indicate',$indicate);

    //防止不可见语音还播报问题
    document.addEventListener('visibilitychange',(e)=>{

        if(document.visibilityState == 'hidden'){

            if($this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE' && $this.$mapStep.type == 'toNAVING'){
                $this.pauseNaving = true;
                $this.isPlay('analog');
            }

            if($VAR.$nav._$voice && !$VAR.$nav._$voice.paused){
                $VAR.$nav._$voice.pause();
            }

        }else{

            if($this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE' && $this.$mapStep.type == 'toNAVING'){

                if($this.$system === 2){
                    if(!$this.pauseNaving){
                        $this.isPlay('analog')
                    }
                }

            }
        }
    })

    //导航中触发重新规划
    $this.bus.$on('navingToChangeRoute',n=>{

        let _callback=(callee)=>{
            $this.bus.$emit('startAndEnd',{
                type:0,
                callback(route){

                    callee && callee(route)
                }
            })
        },
            _success=()=>{
                $this.fixedNavTip =3;

                //隐藏关闭图标
                if($this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){
                    $this.keyPointMarker(1);
                }


                setTimeout(()=>{
                    $this.fixedNavTip = 0;
                },2000);

                $VAR.$nav.resume();

                $this.bus.$emit('navtopSet',{status:4})

            };

        switch (n) {

            case 1:
                //开始规划
                //先暂停导航
                if($VAR.$nav && $VAR.$nav.pause)$VAR.$nav.pause();


                //开启规划动画
                $this.fixedNavTip = 1;

                //实际导航以当前位置规划
                if($this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){
                    //实际导航
                    $brtmap.$selecte.startPoint = Object.assign({},$brtmap.$locate.point)
                }

                _callback(route=>{
                    if(route){
                        _success();
                    }else{
                        $this.fixedNavTip = 2;
                    }
                })

                break;
            case 2:
                //最优路径规划
                if($VAR.$nav && $VAR.$nav.pause)$VAR.$nav.pause();
                $brtmap.$route.ignore = [];
                $this.fixedNavTip = 1;

                _callback(route=>{
                    if(route){
                        $this.$message.info('已默认为您切换为最短路线');
                        _success();
                    }else{
                        $this.fixedNavTip = 0;
                        $this.$message.info('当前点位无符合规划方式,请退出重新选择点位');
                    }
                })

                break;

            default:break;

        }
    })

    $VAR.$nav.on('message',function (indicate) {

        // console.log('message',indicate);

        $indicateTip = indicate;

        let point = $navPoint;

        if(point){
            let navCallee = ()=>{
                let route = $VAR.map.getRouteDistance(point);

                if($indicateTip) {$indicateTip.route = route}

                //获取方向信息
                let dTip = $indicate.getIndicateByPoint(point)

                //获取导航路段信息
                $routes = $indicate.getLineSegment();


                //顶部显示
                $residue = Math.floor(dTip.current.totalLength - dTip.current.passedLength);
                let topTip = {

                    route : $routes,

                    residue: $residue,

                    total : '',

                    passed: '',

                    direction:'',

                    icon:'',

                    directionTXT:'',

                    rssi:$this.$rssi,

                    repeatDIR:false

                }

                //防止数据为null或偏转无属性
                if($indicateTip && $indicateTip.icon !='yaw'){


                    /********导航上报********/
                    if(!startUpdata || parseInt(+new Date - startUpdata) > 1000){

                        if(startUpdata) startUpdata = +new Date();
                        $this.$userUpdata.setNavListener();

                    }

                    //区域触发
                    $this.bus.$emit('navArea',point);


                    //设置导航 （导航类型[1：正常导航；2：模拟导航]， 导航楼层类型[1：跨楼层导航；2：同楼层导航；3：其他]，总长度）
                    if(!startUpdata && $indicateTip && $indicateTip.route){

                        startUpdata = +new Date();

                        let navType = 1;
                        if($this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE') navType = 2;

                        let isSameFloor = 2;
                        if( $routes.some(item=>{return item.floor != $routes[0].floor;}) ){
                            isSameFloor = 1;
                        }

                        $this.$userUpdata.setNavStart(navType,isSameFloor,$indicateTip.route.total);
                    }

                    /********导航上报********/

                        //电梯||楼道||扶梯
                    let tool = '',toUp = 0;

                    if($indicateTip.icon.indexOf('up') > -1 || $indicateTip.icon.indexOf('down')>-1){

                        toUp = 1;

                        if($indicateTip.icon.indexOf('down') > -1){
                            toUp = 2;
                        }

                        //判断是否存在工具节点
                        let _callback = (cid)=>{

                            let isTure = false;

                            if($indicateTip.nodes && $indicateTip.nodes.length){
                                isTure = $indicateTip.nodes.some(item=>{return item.categoryID == cid})
                            }

                            if(isTure)return isTure;

                            //获取本层节点
                            if(!cNodes){
                                if($routes.length){
                                    //取当前层
                                    let nodes = $routes.filter(item=>{
                                        return item.floor == point.floor
                                    });

                                    if(nodes.length){

                                        let node = [];

                                        if(nodes.length>1){
                                            //同层多路段特殊处理
                                            // console.log('同层多路段特殊处理',nodes);

                                            //取最小距离为当前路线
                                            nodes.map(item=>{

                                                item.nodesConcat = [];

                                                //拼接路线所有节点经纬度
                                                item.detail.map(child=>{
                                                    if(child.route.length){
                                                        if(!item.nodesConcat.length){
                                                            item.nodesConcat = child.route;
                                                        }
                                                        else{
                                                            item.nodesConcat = item.nodesConcat.concat(child.route);
                                                        }
                                                    }
                                                })


                                                item.distance = 999999;

                                                //计算最小距离
                                                item.nodesConcat.map(child=>{
                                                    //经纬度转换为地理坐标1
                                                    let LXY = $VAR.map.lnglatToCoords(child),
                                                        d = Math.sqrt((LXY.x-point.x)*(LXY.x-point.x) + (LXY.y-point.y)*(LXY.y-point.y));

                                                    if(d<item.distance)item.distance = d;
                                                })
                                            })

                                            //根据最小距离排序
                                            nodes.sort((v1,v2)=>{
                                                return v1.distance - v2.distance
                                            })

                                        }

                                        nodes[0].detail.map(item=>{

                                            if(item.nodes.length){

                                                if(node.length){
                                                    node = node.concat(item.nodes)
                                                }else{
                                                    node = item.nodes;
                                                }
                                            }

                                        });

                                        cNodes = node;
                                    }

                                }
                            }

                            if(cNodes && cNodes.length){
                                isTure = cNodes.some(item=>{return item.categoryID == cid})
                            }
                            return  isTure;
                        }


                        if(_callback('150012')){
                            tool = '150012';
                        }
                        else if(_callback('150013')){
                            tool = '150013';
                        }else if(_callback('150014')){
                            tool = '150014';
                        }

                    }


                    let obj = {
                        total : $indicateTip.route.total,

                        passed: $indicateTip.route.passed,

                        direction:$indicateTip.icon,

                        icon:$indicateTip.image,

                        tool:tool,

                        toUp:toUp,

                        directionTXT:$indicateTip.subtitle || $indicateTip.title
                    }



                    //防止转角计算错误
                    if($indicateTip.title && !$indicateTip.subtitle){obj.residue = 0}

                    //防止方向错误时误导
                    if(obj.direction && obj.direction.indexOf('err')>-1){obj.residue = '';}

                    //融合
                    topTip = Object.assign({},topTip,obj);
                }

                $this.bus.$emit('navtopSet',topTip);

                let $start = $brtmap.$selecte.startPoint,
                    $end = $brtmap.$selecte.endPoint;



                let $endfname = $end.FLOOR_NAME,
                    $endfnum = $end.FLOOR_NUMBER,
                    $startfnum = $start.FLOOR_NUMBER;


                //终点图标
                if(point.floor == $endfnum){
                    if(!$endStatus){
                        $endStatus = true;
                        $brtmap.$marker.end.setLnglat($VAR.map.coordsToLnglat($end.LABEL_X,$end.LABEL_Y))
                    }
                }
                else{
                    $endStatus = false;
                }

                //起点图标
                $brtmap.$marker.start.empty();
                if(point.floor == $startfnum){

                    if(!$startStatus){
                        $startStatus = true;
                        // $brtmap.$marker.start.setLnglat($VAR.map.coordsToLnglat($start.LABEL_X,$start.LABEL_Y))
                    }

                }
                else{
                    $startStatus = false;
                }

                //底部显示
                $this.floorNAME = $VAR.map.getFloorInfoByIndex(point.floor).floorName;
                $this.endINFO = $end.NAME +'  '+ $endfname;
                $this.distant = Math.floor(topTip.total - topTip.passed);
                $this.minute  = Math.ceil($this.distant / 1.2 / 60);


                //底部3s切换一次
                let $now = +new Date();

                if(!$b_tip_t || $now - $b_tip_t > 10000){
                    $b_tip_t = $now
                }

                if($now - $b_tip_t > 3000){
                    $this.check = !$this.check;
                    $b_tip_t = $now;
                }

                //加载取消
                if($this.moduleState == 6){

                    if($this.$BRT.$NAVTO.NAVType == 'NAVSIMULATE'){
                        $this.moduleState = 4;
                    }else{
                        $this.moduleState = 5;
                    }
                }

                //记录楼层
                if(point.floor !=$floor){

                    //清除上层缓存节点
                    cNodes = '';

                    $floor = point.floor;
                    //保留上一层操作层级
                    if($floorZoom){
                        $VAR.map.stop().easeTo({
                            zoom:$floorZoom
                        })
                    }

                }

                //记录层级
                if($floorZoom != $VAR.map.getZoom()){
                    $floorZoom = $VAR.map.getZoom();
                }
            };

            navCallee();

            //移动情况
            if(+new  Date() - st>600 && $navPoint && indicate){
                st = +new Date();
                let easeTo = {
                    center:$navPoint,
                    duration:500,
                    easing: (value) => {
                        return value
                    }
                };
                //跟随
                if($VAR.$nav.followBearing)easeTo.bearing=indicate.lineAngle;


                $VAR.map.easeTo(easeTo)
            }
        }

        //设置路过终点
        if($indicateTip && $indicateTip.isEnded){
            $VAR.map.setPassedPoint($brtmap.$selecte.navEndPoint);
        }


    })

    $VAR.$nav.on('nav',function (point) {

        $navPoint = point;

        if($VAR.$nav.pointCount<5)$VAR.$nav.pointCount++;

        //处理扫描图标
        $brtmap.$marker.navLocation.setLnglat(point, point.floor,$this.rssi);

        //指针不跟随转动
        if($VAR.$nav.markerFollowRouteAngle){
            $brtmap.$marker.navLocation.setAngle(point.angle);
        }

        //设置路过
        $VAR.map.setPassedPoint(point);

    })

    $VAR.$nav.on('yaw',function (locate,routeIndex,resume) {

        // console.log('locate',locate);

        $this.bus.$emit('navArea',{status:1});
        //偏转提示
        $this.bus.$emit('navtopSet',{status:1});
        $this.moduleState = 6;
        // $this.$message.info('偏离导航中...');
        $brtmap.$selecte.startPoint = JSON.parse(JSON.stringify(locate));

        setTimeout(()=>{    //延迟1s
            $this.bus.$emit('startAndEnd',{
                type:0,
                callback:(routes)=>{

                    if(routes){

                        let callback = ()=>{
                            let lnglat = $VAR.map.coordsToLnglat(locate.x,locate.y),
                                zoom = $floorZoom || $plugNav.defaultRank || 19,
                                pitch = $plugNav.mapAngle || 30;

                            $VAR.map.stop().easeTo({
                                pitch:pitch,
                                center:lnglat,
                                bearing:$brtmap.$NAVTO.initAngle,
                                zoom:zoom
                            })


                            $brtmap.$marker.start.setLnglat(lnglat);

                            $brtmap.$marker.navLocation.setLnglat(lnglat, locate.floor,locate.rssi);//设置位置
                            $brtmap.$marker.navLocation.setAngle(locate.angle);//设置角度

                            $this.$message.info('重新规划路径成功...');

                            //继续执行
                            resume && resume();
                        }

                        if(locate.floor != $VAR.map.currentMapInfo.floorNumber){
                            let $zoom = $VAR.map.getZoom(),
                                $floorId = $VAR.map.getFloorInfoByIndex(locate.floor).floorID;
                            $VAR.map.setFloor($floorId,()=>{
                                $VAR.map.stop().easeTo({
                                    zoom:$zoom
                                })

                                callback && callback();
                            });


                        }
                        else{
                            callback && callback();
                        }

                    }

                }
            });

        },500)

    })


    let $walkEnd = ()=>{

        let _callback = ()=>{

            if($this.backTime<=0){

                $brtmap.$NAVTO.NAVType = 'NAVINDICATE_END';
                $this.loginBtn = true;

                let $start = $brtmap.$selecte.startPoint,
                    $end = $brtmap.$selecte.endPoint;

                //保存历史足迹
                let saveFootsCall = ()=>{
                    // 防止重复保存
                    let $res = $this.$store.state.HistoryData.some((item,index,self)=>{

                        if(
                            $start.POI_ID && $end.POI_ID &&
                            JSON.parse(item.startPoi).POI_ID == $start.POI_ID &&
                            JSON.parse(item.endPoi).POI_ID == $end.POI_ID
                        ){
                            return true;

                        }else{

                            if(
                                JSON.parse(item.endPoi).POI_ID == $end.POI_ID ||
                                JSON.parse(item.startPoi).POI_ID == $start.POI_ID
                            ){

                                if(
                                    !JSON.parse(item.startPoi).POI_ID &&
                                    (!$start.POI_ID || $start.POI_ID=='location') &&
                                    $start.floor == JSON.parse(item.startPoi).floor

                                ){
                                    let _point1 = $start,
                                        _point2 = JSON.parse(item.startPoi),
                                        d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));
                                    if(d < 3){
                                        return  true;
                                    }
                                }

                                if(
                                    !JSON.parse(item.endPoi).POI_ID &&
                                    (!$end.POI_ID || $end.POI_ID == 'location') &&
                                    $end.floor == JSON.parse(item.endPoi).floor
                                ){
                                    let _point1 = $end,
                                        _point2 = JSON.parse(item.endPoi),
                                        d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));
                                    if(d < 3){
                                        return  true;
                                    }
                                }
                            }
                        }
                    })


                    if(!$res){
                        addHistoryFootData($this,{endPoi:$end,startPoi:$start},(res)=>{
                            // console.log('保存历史足迹成功',res);
                            getHistoryFootData($this,($res)=>{  //改变值
                                $this.$store.state.HistoryData = $res.data.result;
                            })
                        })
                    }
                }
                if($this.$mapFunManger.collectAndFoots === 2){
                    if($this.$mapStore.plugInfo.phone){
                        saveFootsCall && saveFootsCall();
                    }
                    else{
                        $this.loginTime = 6;
                        let $loginTo = ()=>{

                            if($this.loginTime <=0 || $this.loginTime > 99){

                                $this.loginBtn = false;
                                return false

                            }

                            $this.loginTime --;

                            setTimeout(()=>{$loginTo()},1000)

                        }
                        $loginTo();
                    }

                }
                else if($this.$mapFunManger.collectAndFoots === 1){
                    saveFootsCall && saveFootsCall();
                }


                let $startfname = $start.floor ? $VAR.map.getFloorInfoByIndex($start.floor).floorName:$start.FLOOR_NAME,
                    $endfname = $end.floor ? $VAR.map.getFloorInfoByIndex($end.floor).floorName:$end.FLOOR_NAME;

                //防止直接触发结束
                if($indicateTip && !$indicateTip.route){
                    let route = $VAR.map.getRouteDistance($navPoint);
                    $indicateTip.route = route
                }

                $this.walk ={
                    Start:$start.NAME + ' '+$startfname,
                    End:$end.NAME+' '+ $endfname,
                    Distant:($indicateTip.route.total / 1000).toFixed(2),
                    Min:Math.ceil($indicateTip.route.total / 1.5 / 60),
                    Fat:($indicateTip.route.total * 0.12 / 7.70).toFixed(2),
                    Omit:Math.ceil($indicateTip.route.total / 1.5 / 60) * 2
                }

                //视图更改为2d
                $this.bus.$emit('locationView',false);

                $this.moduleState = 7;

                $indicateTip = '';

                return;

            }

            $this.backTime --;

            //头部结束处理
            $this.bus.$emit('navtopSet',{status:2});

            //区域触发清空
            $this.bus.$emit('navArea',{status:1});

            //移除图标
            $this.$BRT.$marker.navLocation.empty();
            $this.$BRT.$marker.tipPopup.empty();

            setTimeout(()=>{
                _callback()
            },1000)

        };

        $this.backTime = 3;
        $this.moduleState = 8;
        _callback();
    }


    //退出||或结束导航模式
    let backNav = () =>{
        $door = '';
        startUpdata = false;
        $endStatus = false;
        $startStatus = false;
        $residue = 0;
        cNodes = '';
        st = 0;
        $navPoint='';
        $VAR.$nav.pointCount=0;

        if($this.$BRT.$NAVTO.NAVType == 'NAVINDICATE' && !$this.backStatus){

            $walkEnd();

        }
        else{

            $indicateTip = '';
            $this.clear();

        }
    };

    //中途退出
    $VAR.$nav.on('exit',res=>{backNav()});

    //结束退出
    let $isEnd = false;
    $VAR.$nav.on('ended',point =>{
        if(!$isEnd){

            $isEnd = true;

            //导航正常结束
            $this.$userUpdata.setNavOver();

            $this.bus.$emit('navArea',{status:1});

            backNav();

            //防止连续执行
            setTimeout(()=>{
                $isEnd = false
            },300)
        }
    })
}



//查询poi信息
export function getPoiInfo($brtmap,point,cidNumber) {

    cidNumber = cidNumber || 1100;

    // console.log('point',point);

    var features = $VAR.map.queryRenderedFeatures(point);

    // console.log('features', features);

    for(var i = 0; i < features.length; i++){

        var _layer = features[i].layer;

        if(
            (Math.round(features[i].properties.CATEGORY_ID) > cidNumber) &&
            (   _layer.id.indexOf("indoor") > -1 || _layer.id.indexOf("shade") > -1 ||
                _layer.id.indexOf('label') > -1 || _layer.id.indexOf('facility') > -1 ||
                _layer.id.indexOf('asset') > -1 || _layer.id.indexOf('room') > -1)){

            return features[i].properties;

        }

    }

    return null;
}
